export default __webpack_public_path__ + "static/media/users.919bc619.svg";